import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setPosts(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="blog-page" className="mx-auto max-w-7xl px-6 py-24">
      <p className="label-xs">Blog profesional</p>
      <h1 className="mt-4 max-w-3xl text-5xl tracking-tight sm:text-6xl">Escritos sobre aprender</h1>
      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {posts.map((p, i) => (
          <article key={p.slug} data-testid={`blog-post-${i}`} className="card-nilo flex flex-col p-8">
            <span className="label-xs">{p.categoria}</span>
            <h2 className="mt-5 text-2xl leading-snug">{p.titulo}</h2>
            <p className="mt-4 flex-1 text-sm leading-relaxed text-[#5e5a56]">{p.resumen}</p>
            <span className="mt-6 text-xs text-[#8b8480]">{p.fecha}</span>
          </article>
        ))}
      </div>
    </div>
  );
}
